import fastclick from 'fastclick'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// const HelloWorld = () => import('@/components/HelloWorld')
const Index = () => import('@/views/index')
const Home = () => import('@/views/home')
const PersonalCenter = () => import('@/views/personalCenter')
const HospitalInfo = () => import('@/views/hospitalInfo')
const MedicalGuide = () => import('@/views/dept/medicalGuide')
const PatientList = () => import('@/views/patients/patientList')
const Patient = () => import('@/views/patients/patient')
const OrderList = () => import('@/views/orders/orderList')
const Dept = () => import('@/views/dept/dept')
const DeptIntroduction = () => import('@/views/dept/deptIntroduction')
const Doctor = () => import('@/views/dept/doctor')
const AppointmentDetail = () => import('@/views/dept/appointmentDetail')
const DoctorSchedule = () => import('@/views/dept/doctorSchedule')
const ScheduleByDoctor = () => import('@/views/dept/scheduleByDoctor')
const takeTicket = () => import('@/views/takeTicket/appointList')
const IntelligentTriage = () => import('@/views/intelligentTriage/intelligentTriage')
const success = () => import('@/views/dept/success')
const patientCard = () => import('@/views/patients/card')
const help = () => import('@/views/help/help')
const drug = () => import('@/views/drug/drug')
const drugZ = () => import('@/views/drug/drug-z')
const error = () => import('@/views/404')
const patientEdit = () => import('@/views/patients/patient-edit')
const nucleicAcidAppoint = () => import('@/views/nucleicAcid/nucleicAcidAppointment')
const vaccineAppoint = () => import('@/views/vaccine/vaccineAppoint')
const nucleicAcidList = () => import('@/views/nucleicAcid/nucleicAcidList')
const vaccineAppointment = () => import('@/views/vaccine/vaccineAppointment')
const vaccineList = () => import('@/views/vaccine/vaccineList')
const vaccineDetail = () => import('@/views/vaccine/vaccineDetail')
const operationGuidance = () => import('@/views/help/operationGuidance')
const nucleicAcidQuery = () => import('@/views/nucleicAcid/nucleicAcidQuery')
const getUserInformation = () => import('@/views/getUserInformation')
const outpatient = () => import('@/views/satisfaction/outpatient')
const hospitalization = () => import('@/views/satisfaction/hospitalization')
const survey = () => import('@/views/satisfaction/index')
// 名医风采 详情页面
const doctorDetail = () => import('@/views/doctor/doctorDetail')

// 体检中心 套餐列表
const checkupList = () => import('@/views/checkup/checkupList')

// 体检套餐详情
const checkupDetail = () => import('@/views/checkup/checkupDetail')

// 新增投诉建议
const complaint = () => import('@/views/complaint/complaint')

// 我的投诉建议列表
const complaintList = () => import('@/views/complaint/complaintList')

// 我的投诉建议详情
const complaintDetail = () => import('@/views/complaint/complaintDetail')

// 体检预约确认
const checkupConfirm = () => import('@/views/checkup/checkupConfirm')

// 我的体检预约
const myCheckupList = () => import('@/views/checkup/myCheckupList')

// 滚动图信息中心
const info = () => import('@/views/bannerInfo/info')

// 体检报告列表
const healthCheckReportList = () => import('@/views/healthCheckReport/healthCheckReportList')

// 体检报告详情
const healthCheckReportDetail = () => import('@/views/healthCheckReport/healthCheckReportDetail')


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index,
      children: [
        { path: '', component: Home },
        { path: 'personalCenter', component: PersonalCenter },
        { path: 'hospitalInfo', component: HospitalInfo }
      ],
      meta: {
        wechatAuth: true // 如果此路由需要微信授权请设置为true,默认为false
        // wechatAuth: false // 如果此路由需要微信授权请设置为true,默认为false
      }
    },
    {
      path: '/takeTicket',
      name: 'takeTicket',
      component: takeTicket
    },
    {
      path: '/patientList',
      name: 'patientList',
      component: PatientList
    },
    {
      path: '/patient',
      name: 'patient',
      component: Patient,
      props: (route) => ({ query: route.query.q })
    },
    {
      path: '/patientEdit',
      name: 'patientEdit',
      component: patientEdit,
      props: (route) => ({ query: route.query.q })
    },
    {
      path: '/patientCard',
      name: 'patientCard',
      component: patientCard
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: OrderList
    },
    {
      path: '/dept',
      name: 'dept',
      component: Dept
    },
    {
      path: '/medicalGuide',
      name: 'medicalGuide',
      component: MedicalGuide
    },
    {
      path: '/deptIntroduction',
      name: 'deptIntroduction',
      component: DeptIntroduction
    },
    {
      path: '/doctor',
      name: 'doctor',
      component: Doctor,
      props: (route) => ({ query: route.query.q })
    },
    {
      path: '/success',
      name: 'success',
      component: success
      // props: (route) => ({ query: route.query.q })
    },
    {
      path: '/appointmentDetail',
      name: 'appointmentDetail',
      component: AppointmentDetail,
      props: (route) => ({ query: route.query.q })
    },
    {
      path: '/doctorSchedule',
      name: 'doctorSchedule',
      component: DoctorSchedule,
      props: (route) => ({ query: route.query.q })
    },
    {
      path: '/scheduleByDoctor',
      name: 'scheduleByDoctor',
      component: ScheduleByDoctor,
      props: (route) => ({ query: route.query.q })
    },
    {
      path: '/intelligentTriage',
      name: 'intelligentTriage',
      component: IntelligentTriage
    },
    {
      path: '/help',
      name: 'help',
      component: help
    },
    {
      path: '/drug',
      name: 'drug',
      component: drug
    },
    {
      path: '/drugZ',
      name: 'drugZ',
      component: drugZ
    },
    {
      path: '/404',
      name: '404',
      component: error
    },
    {
      path: '/nucleicAcidQuery',
      name: 'nucleicAcidQuery',
      component: nucleicAcidQuery
    },
    {
      path: '/nucleicAcidAppointment',
      name: 'nucleicAcidAppointment',
      component: nucleicAcidAppoint
    },
    {
      path: '/nucleicAcidList',
      name: 'nucleicAcidList',
      component: nucleicAcidList
    },
    {
      path: '/vaccineAppointment',
      name: 'vaccineAppointment',
      component: vaccineAppointment
    },
    {
      path: '/vaccineList',
      name: 'vaccineList',
      component: vaccineList
    },
    {
      path: '/vaccineDetail',
      name: 'vaccineDetail',
      component: vaccineDetail
    },
    {
      path: '/operationGuidance',
      name: 'operationGuidance',
      component: operationGuidance
    },
    {
      path: '/vaccineAppoint',
      name: 'vaccineAppoint',
      component: vaccineAppoint
    },
    {
      path: '/getUserInformation',
      name: 'getUserInformation',
      component: getUserInformation,
      meta: {
        wechatAuth: true // 如果此路由需要微信授权请设置为true,默认为false
        // wechatAuth: false // 如果此路由需要微信授权请设置为true,默认为false
      }
    },
    {
      path: '/outpatient',
      name: 'outpatient',
      component: outpatient,
      meta: {
        //wechatAuth: true // 如果此路由需要微信授权请设置为true,默认为false
         wechatAuth: false // 如果此路由需要微信授权请设置为true,默认为false
      }
    },
    {
      path: '/hospitalization',
      name: 'hospitalization',
      component: hospitalization,
      meta: {
        //wechatAuth: true // 如果此路由需要微信授权请设置为true,默认为false
         wechatAuth: false // 如果此路由需要微信授权请设置为true,默认为false
      }
    },
    {
      path: '/survey',
      name: 'survey',
      component: survey,
      meta: {
        //wechatAuth: true // 如果此路由需要微信授权请设置为true,默认为false
         wechatAuth: false // 如果此路由需要微信授权请设置为true,默认为false
      }
    },


    // 医生详情
    {
      path: '/doctorDetail',
      name: 'doctorDetail',
      component: doctorDetail,
      props: (route) => ({ query: route.query.q })
    },

    // 体检套餐列表
    {
      path: '/checkupList',
      name: 'checkupList',
      component: checkupList,
      meta: {
        wechatAuth: true // 如果此路由需要微信授权请设置为true,默认为false
        // wechatAuth: false // 如果此路由需要微信授权请设置为true,默认为false
      }
    },

    // 体检套餐详情
    {
      path: '/checkupDetail',
      name: 'checkupDetail',
      component: checkupDetail,
      props: (route) => ({ query: route.query.q })
    },

    // 新增投诉建议
    {
      path: '/complaint',
      name: 'complaint',
      component: complaint,
      meta: {
        wechatAuth: true // 如果此路由需要微信授权请设置为true,默认为false
        // wechatAuth: false // 如果此路由需要微信授权请设置为true,默认为false
      }
    },

    // 我的投诉建议列表
    {
      path: '/complaintList',
      name: 'complaintList',
      component: complaintList,
    },

    // 我的投诉建议详情
    {
      path: '/complaintDetail',
      name: 'complaintDetail',
      component: complaintDetail,
      props: (route) => ({ query: route.query.q })
    },

    // 体检预约确认
    {
      path: '/checkupConfirm',
      name: 'checkupConfirm',
      component: checkupConfirm,
      props: (route) => ({ query: route.query.q })
    },

    // 我的体检预约
    {
      path: '/myCheckupList',
      name: 'myCheckupList',
      component: myCheckupList
    },

    // 滚动图信息中心
    {
      path: '/info',
      name: 'info',
      component: info,
      props: (route) => ({ query: route.query.q })
    },

    // 体检报告列表
    {
      path: '/healthCheckReportList',
      name: 'healthCheckReportList',
      component: healthCheckReportList,
      meta: {
        wechatAuth: true
      }
    },

    // 体检报告详情
    {
      path: '/healthCheckReportDetail',
      name: 'healthCheckReportDetail',
      component: healthCheckReportDetail,
      props: (route) => ({ query: route.query.q })
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js